import { useField } from "formik";
import { ServiceType } from "../../helper/serviceType";

export const useServiceType = () => {
  const [{ value }] = useField<string | undefined>("service_type");

  const serviceType = value?.toLowerCase() as ServiceType | undefined;

  return {
    serviceType,
    isPrint: value === "PRINT",
    isEmbroidery: value === "EMBROIDERY",
  };
};
